import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Notification Bar",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-notification-bar",
    args: {
        background: "grey",
        iconName: "globe",
        headline: "Welcome to our white-themed notification!",
        copy:
            "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et  justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam.",
        buttonText: "learn more",
    },
    argTypes: {
        background: {
            options: ["grey", "white", "green", "blue"],
            control: { type: "radio" },
        },
        iconName: {
            control: {
                type: "text",
            },
        },
        headline: {
            control: {
                type: "text",
            },
        },
        copy: {
            control: {
                type: "text",
            },
        },
        buttonText: {
            control: {
                type: "text",
            },
        },
    },
};

const Template = (args) => {
    if (args.background === "white") {
        return html`
            <ux-iws-notification-bar
                background="${args.background}"
                icon-name="${args.iconName}"
            >
                <h2
                    class="ux-text-headline ux-text-headline--medium"
                    slot="title"
                >
                    ${args.headline}
                </h2>
                <div class="ux-text-normal" slot="copy">
                    <p>
                        ${args.copy}
                    </p>
                </div>
                <ux-button href="#">${args.buttonText}</ux-button>
            </ux-iws-notification-bar>
        `;
    } else {
        return html`
            <ux-iws-notification-bar
                background="${args.background}"
                icon-name="${args.iconName}"
            >
                <h2
                    class="ux-text-headline ux-text-headline--medium"
                    slot="title"
                >
                    ${args.headline}
                </h2>
                <div class="ux-text-normal" slot="copy">
                    <p>
                        ${args.copy}
                    </p>
                </div>
                <ux-button href="#">${args.buttonText}</ux-button>
            </ux-iws-notification-bar>
        `;
    }
};

export const Default = Template.bind({});
